import parentKidMethods from './Parent.kid'
import linkKidMethods from './Parent.linkKid'

export const KidServices = {
  ...parentKidMethods,
  link: linkKidMethods
}

export * from './Kid.types'
